import React from 'react';
import { Divider } from '@mui/material';

import Screen from '../Screen';
import InputVerificationCode from '../InputVerificationCode';
import ButtonPrimary from '../ButtonPrimary';
import Form from '../Form';

import useForm from './useForm';
import usePrequal from '../../resources/prequal/usePrequal';
import AccordionOptions from './AccordionOptions';

const VerifyPhone = ({ onUpdate }) => {
  const { data: prequal } = usePrequal();

  const {
    form,
    handleSubmit,
    isSubmitting,
  } = useForm();

  return (
    <Screen
      header="Verify your mobile number."
      subheader={(
        <>
          Enter the six-digit verification code that was sent to
          <br />
          <b>
            (•••) •••-
            {prequal?.phone?.slice(8, 12)}
          </b>
        </>
      )}
    >
      <Form
        form={form}
        onSubmit={handleSubmit}
      >
        <InputVerificationCode />
        <ButtonPrimary isLoading={isSubmitting}>
          Verify
        </ButtonPrimary>
      </Form>
      <Divider />
      <AccordionOptions onUpdate={onUpdate} />
    </Screen>
  );
};

export default VerifyPhone;
